import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useState } from 'react';

import useCertification from './hooks/useCertification';
import styles from './styles.module.scss';

function Certification() {
  const {
    requestColor, verityColor, onChangePhone, phoneNo,
    code, onChangeCode, requestSms, requestVerify,
    // isVerified, certPhoneNo,
  } = useCertification();
  return (
        <Column as='section'
                fullWidth
                spacing={12}
                className={styles.container}>
            <Text size='xl' fontWeight='bold'>
                회원정보
            </Text>
            <Text color={colors.gray7} fontWeight='bold'
                  size='lg'
                  className={styles.comment} >
                휴대전화번호를 입력해주세요
            </Text>
            <Column fullWidth spacing={12} >
                <TextField placeholder="'-'없이 입력 숫자만 입력"
                           value={phoneNo}
                           onChange={onChangePhone}
                           maxLength={13}
                           // readOnly={!!certPhoneNo}
                           inputMode='numeric'
                           trailing={
                               <ButtonWrapper type='button'
                                   onClick={requestSms} >
                                   <Text fontWeight='bold' color={requestColor}
                                         className={styles.button} >인증요청</Text>
                               </ButtonWrapper>
                           } />
                <TextField placeholder='인증번호 6자 숫자만 입력'
                           maxLength={6}
                           value={code}
                           onChange={onChangeCode}
                           // readOnly={isVerified}
                           inputMode='numeric'
                           trailing={
                               <ButtonWrapper type='button'
                                              onClick={requestVerify}>
                                   <Text fontWeight='bold' color={verityColor}
                                         className={styles.button} >번호인증</Text>
                               </ButtonWrapper>
                           } />
            </Column>
            <Row spacing={6}>
                <Text color={colors.gray5}
                      size='s' >
                    <b>개인 정보 수탁사</b> NHN
                </Text>
                <div className={styles.div}/>
                <Text color={colors.gray5}
                      size='s' >
                    <b>업무의 내용</b> 인증번호 문자 발송 대행
                </Text>
            </Row>
        </Column>
  );
}

const ButtonWrapper = styled.button`
    padding: 8px 12px;
    background-color: transparent;
`;

export default Certification;
